export const toneBadge: Record<string, string> = {
  primary: "bg-primary-100 text-primary-800",
  accent: "bg-accent-100 text-accent-800",
  secondary: "bg-secondary-100 text-secondary-800",
};

export const toneIconWrap: Record<string, string> = {
  primary: "bg-primary-500/15 text-primary-700",
  accent: "bg-accent-500/15 text-accent-700",
  secondary: "bg-secondary-500/15 text-secondary-700",
};

export const toneSolid: Record<string, string> = {
  primary: "bg-primary-500 text-foreground-950",
  accent: "bg-accent-500 text-background-50",
  secondary: "bg-secondary-500 text-background-50",
};

export const platformIcons: Record<string, string> = {
  Windows: "ri-windows-fill",
  macOS: "ri-apple-fill",
  Android: "ri-android-fill",
  iOS: "ri-apple-fill",
  Web: "ri-global-line",
};